import BespokeMarketManager from './BespokeMarketManager'

const $bespokeMarketManager = new BespokeMarketManager()

export default $bespokeMarketManager
